var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "hello" },
    [
      _c(
        "viewer",
        { attrs: { images: this.image } },
        _vm._l(this.image, function(form, i) {
          return _c(
            "div",
            {
              key: form.id,
              staticClass: "gallary_image",
              attrs: { id: "imgBox" + i }
            },
            [
              _c("img", {
                staticClass: "gallary_image",
                attrs: {
                  id: form.id,
                  src: "data:" + form.type.trim() + ";base64," + form.img
                }
              })
            ]
          )
        }),
        0
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8945f2a8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8945f2a8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Common/image-upload/ViewerConfirm.vue
// module id = null
// module chunks = 